import { createVanIconComponent } from "./van"

const PauseCircleOutlined = createVanIconComponent("pause-circle-o")
export default PauseCircleOutlined
